import List from './List';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'external_accounts',
  inputShow: gql`
    query externalAccounts($input: ExternalAccountQueryInput) {
      externalAccounts(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  show: Show,
  options: {
    group: 'Billing',
    label: 'External Accounts',
  },
};
